import { useEffect, useRef, useState } from 'react'
import { Accordion, Col, Row } from 'react-bootstrap'
import { CoursesListVM } from '../../../Structure/ViewModels/Admin/CoursesListVM'
import PeriodEditing from './PeriodEditing'
import ItemTab from './ItemTab'

const CoursesList = (props:{vm:CoursesListVM}) => {
    const [vm , setVm] = useState<{viewModel:CoursesListVM}>({viewModel:props.vm})
    const control = vm.viewModel
    useEffect(()=>{ 
        control.subscribeUpdate(setVm)
        control.getCourses()
    },[])

    const [newCourse, setNewCourse] = useState('')

    const addingButtonRef = useRef<HTMLDivElement>(null)
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>)=>{
        if(event.key === 'Enter' && addingButtonRef.current){
            addingButtonRef.current.click()
        }
    }

    useEffect(()=>{
        control.load()
    },[control.SelectedCourse])

  return (
    <Accordion defaultActiveKey={'0'} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
        <Accordion.Item eventKey='0' className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}} >
            <Accordion.Button  className='border-0 border-bottom' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
                <h5 className='ps-3 px-2'>
                    الكورسات
                </h5>
            </Accordion.Button>
            <Accordion.Body  className=' d-flex flex-column justify-content-between overflow-y-auto' >
            {
                control.Show(
                <Row className='h-100  overflow-y-auto'>
                    <Col xl={4} className=' p-1 pt-4 p-3  py-5 d-flex flex-column justify-content-between'   style={{maxHeight:'350px'}}>
                        <div className=' overflow-y-scroll'>
                        {
                            control.CoursesList.map((item , index)=>(
                                <ItemTab key={index} id={item.id} value={item.course} dataType='الكورس' index={index} selected={control.SelectedCourse === item.id} onSelect={a=>control.SelectedCourse = a} onDelete={a=>control.removeCourse(a)} />
                            ))
                        }
                        </div>
                        <div className='d-flex pt-2'>
                            <input type="text" className='w-100 input-field' onKeyDown={handleKeyDown} value={newCourse} onChange={a=>setNewCourse(a.target.value)} />
                            <div className='px-3'></div>
                            <div ref={addingButtonRef} className={`material-symbols-outlined success-item c-pointer m-auto fs-3 px-2`} onClick={()=>{ control.addCourse(newCourse); setNewCourse('')} } > add  </div>
                        </div>
                    </Col>

                    <Col xl={8} className=' p-1  p-3 py-5 d-flex flex-column justify-content-between'   style={{maxHeight:'350px',minHeight:'200px'}}>
                        <div className=' overflow-y-scroll'>
                            {
                                control.CourseDetails.periods.map((item , index)=>(
                                    <PeriodEditing key={index} details={item} vm={control} />
                                ))
                            }
                            <PeriodEditing courseId={control.CourseDetails.id}  vm={control} />
                        </div>
                    </Col>
                </Row>)
                }
            </Accordion.Body>
        </Accordion.Item>    
    </Accordion>
  )
}

export default CoursesList
